// @ts-nocheck
import './ContentBuilderTemplate.scss';

import React from 'react';

import { forwardRefWithAs } from '../../../utils/types/PropsWithAsAttributes';
import { usePropsHandler } from '../../EventInterceptor/usePropsHandler';

import { cnContentBuilderTemplate } from './index';

import { Typography } from '@dataartdev/uikit/Typography';
import { Slider, SliderItem } from '@dataartdev/uikit/Slider';
import { MemberCard } from '@dataartdev/uikit/MemberCard';
import { generatePath } from 'react-router-dom';
import { useIntl } from 'react-intl';

export type Props = {
  type?: number;
};

export const ContentBuilderTemplate = forwardRefWithAs<Props>((props, ref) => {
  const {
    type,
    title,
    members,
    aliases,
    cardAttrs,
    contentId,
  } = usePropsHandler(cnContentBuilderTemplate(), props);

  const typeNumber = type.toString();
  const { locale } = useIntl();

  const options = {
    watchOverflow: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    navigation: true,
    breakpoints: {
      767: {
        spaceBetween: 16,
      },
      1199: {
        spaceBetween: 24,
      },
    },
  };

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      {title && (
        <Typography.Title
          size="lg"
          className={cnContentBuilderTemplate('Title')}
          as="h2"
        >
          {title}
        </Typography.Title>
      )}

      {members && members.length > 0 && (
        <Slider {...options}>
          {members.map(member => {
            return (
              <SliderItem key={member.id}>
                <MemberCard
                  {...member}
                  routePath={
                    member.type === 1
                      ? generatePath(aliases.TEAM_ADVISOR, {
                          slug: member.slug,
                          lang: locale === 'en' ? null : locale,
                        })
                      : generatePath(aliases.TEAM_MEMBER, {
                          slug: member.slug,
                          lang: locale === 'en' ? null : locale,
                        })
                  }
                  {...cardAttrs}
                />
              </SliderItem>
            );
          })}
        </Slider>
      )}
    </div>
  );
});

export default ContentBuilderTemplate;
